module.exports = __webpack_public_path__ + "img/3.4fc2f4c6.jpg";